<div class="card tile-shadow">
  <div class="card-header header bg-white">
    <div class="row">
      <div class="col-10"><h3 class="fw-bold">Your Advisors</h3></div>
      <div class="col-2 text-end">
        <img src="assets/icons/headset.svg" />
      </div>
    </div>
  </div>
  <div class="list-group list-group-flush">
    <div class="list-group-item" *ngFor="let advisor of advisors">
      <div class="row">
        <div class="col-auto">
          <img src="assets/icons/useravatar.svg" />
        </div>
        <div class="col">
          <div class="d-flex justify-content-between align-items-center h-100">
            <div class="d-flex flex-column">
              <span class="fw-bold">{{ advisor.advisorName }}</span>
              <small *ngIf="advisor.advisorType == 'PSP'">Payroll Specialist</small>
              <small *ngIf="advisor.advisorType != 'PSP'">{{ advisor.advisorType }}</small>
            </div>
            <span class="mb-auto mt-auto">{{ advisor.advisorPhoneNumber }}</span>
            <a class="mb-auto mt-auto" [href]="'mailto:' + advisor.advisorEmail">{{
              advisor.advisorEmail
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
